import React from "react";
import { useNavigate } from "react-router-dom";
import "./ActionButton.css";

const ActionButton = ({ text, to, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <button
      className="action-button"
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default ActionButton;
